import { Component, inject, signal, viewChild } from "@angular/core";
import { FormsModule, NgForm } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatButtonLoadingDirective } from "app/common-ux/button/button-loading.directive";
import { AuthenticationService } from "app/auth/authentication.service";

@Component({
    selector: "app-forgot-password",
    templateUrl: "./forgot-password.component.html",
    styleUrls: ["./forgot-password.component.scss"],
    imports: [
        FormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonLoadingDirective,
    ],
})
export class ForgotPasswordComponent {
    private authenticationService = inject(AuthenticationService);

    public resetForm = viewChild.required<NgForm>("resetForm");
    public email = "";
    public resetState = signal({
        isInvalid: false,
        isResetting: false,
        sentSuccessfully: false,
    });

    public async requestPasswordReset() {
        try {
            this.resetState.update((s) => ({
                ...s,
                isInvalid: false,
                sentSuccessfully: false,
                isResetting: true,
            }));
            await this.authenticationService.requestPasswordReset(this.email);
            this.resetForm().form.disable();
            this.resetState.update((s) => ({ ...s, sentSuccessfully: true }));
        } catch (e) {
            this.resetState.update((s) => ({ ...s, isInvalid: true }));
        } finally {
            this.resetState.update((s) => ({ ...s, isResetting: false }));
        }
    }
}
